import type React from 'react'
import styled from 'styled-components'
import { ContainerSimple } from '../Container'
import type { IContainerSimpleProps } from '../Container/ContainerSimple'

interface ILabelNonBreakableProps extends IContainerSimpleProps {
  // display 3 dots when the oneline character is too long
  ellipsis?: boolean
}

/** @deprecated */
const LabelNonBreakable: React.FC<ILabelNonBreakableProps> = props => {
  return (
    <ContainerSimple name="LabelNonBreakable" {...props} inline>
      {props.children}
    </ContainerSimple>
  )
}

export default styled(LabelNonBreakable)`
  white-space: nowrap;
  overflow: ${props => (props.ellipsis ? 'hidden' : 'initial')};
  text-overflow: ${props => (props.ellipsis ? 'ellipsis' : 'initial')};
`
